// Auto-generated resource for Rehearsal — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const RehearsalKeys = {
  Validations: {
    RequiresPremium: 'Rehearsal.Validations.RequiresPremium',
    DoesNotExist: 'Rehearsal.Validations.DoesNotExist',
    InvalidTag: 'Rehearsal.Validations.InvalidTag',
    TagNotUnique: 'Rehearsal.Validations.TagNotUnique',
    SeriesConcluded: 'Rehearsal.Validations.SeriesConcluded',
    SeriesNotYours: 'Rehearsal.Validations.SeriesNotYours',
    DocumentEmpty: 'Rehearsal.Validations.DocumentEmpty',
    DocumentTooLong: 'Rehearsal.Validations.DocumentTooLong',
    TalkTooShort: 'Rehearsal.Validations.TalkTooShort',
    TypedTalkTooLong: 'Rehearsal.Validations.TypedTalkTooLong',
    DocumentConvertFailed: 'Rehearsal.Validations.DocumentConvertFailed',
    DocumentUnsupportedType: 'Rehearsal.Validations.DocumentUnsupportedType',
    SourceTooLarge: 'Rehearsal.Validations.SourceTooLarge',
    PdfTooManyPages: 'Rehearsal.Validations.PdfTooManyPages',
    NothingToParse: 'Rehearsal.Validations.NothingToParse',
    SeriesRequired: 'Rehearsal.Validations.SeriesRequired',
    NoDocument: 'Rehearsal.Validations.NoDocument',
    PlanFailed: 'Rehearsal.Validations.PlanFailed',
    TooManyPlans: 'Rehearsal.Validations.TooManyPlans',
    PlanNameTooLong: 'Rehearsal.Validations.PlanNameTooLong',
    PlanIdRequired: 'Rehearsal.Validations.PlanIdRequired',
    PlanInFlight: 'Rehearsal.Validations.PlanInFlight',
    UnknownPlanModel: 'Rehearsal.Validations.UnknownPlanModel',
  },
  Series: {
    Eyebrow: 'Rehearsal.Series.Eyebrow',
    SectionHeading: 'Rehearsal.Series.SectionHeading',
    Restoring: 'Rehearsal.Series.Restoring',
    Searching: 'Rehearsal.Series.Searching',
    FindLabel: 'Rehearsal.Series.FindLabel',
    FindPlaceholder: 'Rehearsal.Series.FindPlaceholder',
    RecentGroup: 'Rehearsal.Series.RecentGroup',
    NoMatches: 'Rehearsal.Series.NoMatches',
    StartNew: 'Rehearsal.Series.StartNew',
    Joined: 'Rehearsal.Series.Joined',
    Change: 'Rehearsal.Series.Change',
    CreateFailed: 'Rehearsal.Series.CreateFailed',
    ViewSeries: 'Rehearsal.Series.ViewSeries',
    AllSeries: 'Rehearsal.Series.AllSeries',
  },
  Chain: {
    StepDone: 'Rehearsal.Chain.StepDone',
    StepCurrent: 'Rehearsal.Chain.StepCurrent',
    StepLocked: 'Rehearsal.Chain.StepLocked',
    SeriesTitle: 'Rehearsal.Chain.SeriesTitle',
    TalkTitle: 'Rehearsal.Chain.TalkTitle',
    PractiseTitle: 'Rehearsal.Chain.PractiseTitle',
    StartTitle: 'Rehearsal.Chain.StartTitle',
    ReviewTitle: 'Rehearsal.Chain.ReviewTitle',
    ReviewSummary: 'Rehearsal.Chain.ReviewSummary',
    TalkIntro: 'Rehearsal.Chain.TalkIntro',
    TalkLocked: 'Rehearsal.Chain.TalkLocked',
    PractiseLocked: 'Rehearsal.Chain.PractiseLocked',
    StartLocked: 'Rehearsal.Chain.StartLocked',
    StartNeedsPlan: 'Rehearsal.Chain.StartNeedsPlan',
    StartManual: 'Rehearsal.Chain.StartManual',
    StartAssistedOne: 'Rehearsal.Chain.StartAssistedOne',
    StartAssistedMany: 'Rehearsal.Chain.StartAssistedMany',
    StartTake: 'Rehearsal.Chain.StartTake',
    StartPitching: 'Rehearsal.Chain.StartPitching',
    StartLive: 'Rehearsal.Chain.StartLive',
    StartLivePanel: 'Rehearsal.Chain.StartLivePanel',
    StartLiveNotReady: 'Rehearsal.Chain.StartLiveNotReady',
  },
  Resume: {
    TakesOne: 'Rehearsal.Resume.TakesOne',
    TakesMany: 'Rehearsal.Resume.TakesMany',
    NoTakesYet: 'Rehearsal.Resume.NoTakesYet',
    About: 'Rehearsal.Resume.About',
  },
  Preview: {
    SeriesTopic: 'Rehearsal.Preview.SeriesTopic',
    SeriesTag: 'Rehearsal.Preview.SeriesTag',
    TakesHeading: 'Rehearsal.Preview.TakesHeading',
    Take: 'Rehearsal.Preview.Take',
    MustOne: 'Rehearsal.Preview.MustOne',
    MustTwo: 'Rehearsal.Preview.MustTwo',
    MustThree: 'Rehearsal.Preview.MustThree',
    IfTimeOne: 'Rehearsal.Preview.IfTimeOne',
    IfTimeTwo: 'Rehearsal.Preview.IfTimeTwo',
    PitchHeading: 'Rehearsal.Preview.PitchHeading',
  },
  Listing: {
    Title: 'Rehearsal.Listing.Title',
    Heading: 'Rehearsal.Listing.Heading',
    Lead: 'Rehearsal.Listing.Lead',
    SearchLabel: 'Rehearsal.Listing.SearchLabel',
    SearchHint: 'Rehearsal.Listing.SearchHint',
    Loading: 'Rehearsal.Listing.Loading',
    LoadFailed: 'Rehearsal.Listing.LoadFailed',
    EmptyHeading: 'Rehearsal.Listing.EmptyHeading',
    EmptyBody: 'Rehearsal.Listing.EmptyBody',
    TryRehearsal: 'Rehearsal.Listing.TryRehearsal',
    NoMatch: 'Rehearsal.Listing.NoMatch',
    OpenSeries: 'Rehearsal.Listing.OpenSeries',
    CreatedOn: 'Rehearsal.Listing.CreatedOn',
    ShowConcluded: 'Rehearsal.Listing.ShowConcluded',
    Concluded: 'Rehearsal.Listing.Concluded',
    NoDocument: 'Rehearsal.Listing.NoDocument',
    TypedTalk: 'Rehearsal.Listing.TypedTalk',
    TotalDocumentBytes: 'Rehearsal.Listing.TotalDocumentBytes',
    ShowArchived: 'Rehearsal.Listing.ShowArchived',
    Archived: 'Rehearsal.Listing.Archived',
    Archive: 'Rehearsal.Listing.Archive',
    Unarchive: 'Rehearsal.Listing.Unarchive',
    ArchiveHint: 'Rehearsal.Listing.ArchiveHint',
    ArchiveFailed: 'Rehearsal.Listing.ArchiveFailed',
  },
  Detail: {
    Eyebrow: 'Rehearsal.Detail.Eyebrow',
    LockedHeading: 'Rehearsal.Detail.LockedHeading',
    LockedLead: 'Rehearsal.Detail.LockedLead',
    Loading: 'Rehearsal.Detail.Loading',
    LoadFailed: 'Rehearsal.Detail.LoadFailed',
    TakeHeading: 'Rehearsal.Detail.TakeHeading',
    UnattachedTake: 'Rehearsal.Detail.UnattachedTake',
    TakenOn: 'Rehearsal.Detail.TakenOn',
    NoTakesYet: 'Rehearsal.Detail.NoTakesYet',
    LocalOnlyTakesOne: 'Rehearsal.Detail.LocalOnlyTakesOne',
    LocalOnlyTakesMany: 'Rehearsal.Detail.LocalOnlyTakesMany',
    NoReviewYet: 'Rehearsal.Detail.NoReviewYet',
    RequestReview: 'Rehearsal.Detail.RequestReview',
    RequestReviewFailed: 'Rehearsal.Detail.RequestReviewFailed',
    ReviewsHeading: 'Rehearsal.Detail.ReviewsHeading',
    OpenReview: 'Rehearsal.Detail.OpenReview',
    LockedTitle: 'Rehearsal.Detail.LockedTitle',
    LockedBody: 'Rehearsal.Detail.LockedBody',
    TakesSoFarOne: 'Rehearsal.Detail.TakesSoFarOne',
    TakesSoFarMany: 'Rehearsal.Detail.TakesSoFarMany',
    DiffHeading: 'Rehearsal.Detail.DiffHeading',
    TakesHeading: 'Rehearsal.Detail.TakesHeading',
    SelectTake: 'Rehearsal.Detail.SelectTake',
    BadgeReviewed: 'Rehearsal.Detail.BadgeReviewed',
    BadgePending: 'Rehearsal.Detail.BadgePending',
    BadgeNoReview: 'Rehearsal.Detail.BadgeNoReview',
    CompareWith: 'Rehearsal.Detail.CompareWith',
    DiffAgainst: 'Rehearsal.Detail.DiffAgainst',
    NothingToCompare: 'Rehearsal.Detail.NothingToCompare',
    TrendsHeading: 'Rehearsal.Detail.TrendsHeading',
    TrendsNote: 'Rehearsal.Detail.TrendsNote',
    ConcludedBanner: 'Rehearsal.Detail.ConcludedBanner',
    RecordedAgainst: 'Rehearsal.Detail.RecordedAgainst',
    Rehearse: 'Rehearsal.Detail.Rehearse',
    ArchivedBanner: 'Rehearsal.Detail.ArchivedBanner',
    Archive: 'Rehearsal.Detail.Archive',
    Unarchive: 'Rehearsal.Detail.Unarchive',
    ArchiveHint: 'Rehearsal.Detail.ArchiveHint',
    ArchiveFailed: 'Rehearsal.Detail.ArchiveFailed',
    Rename: 'Rehearsal.Detail.Rename',
    RenameLabel: 'Rehearsal.Detail.RenameLabel',
    RenameSave: 'Rehearsal.Detail.RenameSave',
    RenameCancel: 'Rehearsal.Detail.RenameCancel',
    RenameFailed: 'Rehearsal.Detail.RenameFailed',
  },
  Page: {
    Title: 'Rehearsal.Page.Title',
    MetaDescription: 'Rehearsal.Page.MetaDescription',
    Heading: 'Rehearsal.Page.Heading',
    Lead: 'Rehearsal.Page.Lead',
    FormulaHeading: 'Rehearsal.Page.FormulaHeading',
    FormulaIntro: 'Rehearsal.Page.FormulaIntro',
    ModeLabel: 'Rehearsal.Page.ModeLabel',
    ModeAssisted: 'Rehearsal.Page.ModeAssisted',
    ModeManual: 'Rehearsal.Page.ModeManual',
    ModeAssistedHint: 'Rehearsal.Page.ModeAssistedHint',
    ModeAssistedNotePoints: 'Rehearsal.Page.ModeAssistedNotePoints',
    ModeAssistedNoteOff: 'Rehearsal.Page.ModeAssistedNoteOff',
    ModeManualHint: 'Rehearsal.Page.ModeManualHint',
    ModeManualNoteBrowser: 'Rehearsal.Page.ModeManualNoteBrowser',
    ModeManualNoteUpload: 'Rehearsal.Page.ModeManualNoteUpload',
    TakeTitle: 'Rehearsal.Page.TakeTitle',
    TakeKindLabel: 'Rehearsal.Page.TakeKindLabel',
    SignInHint: 'Rehearsal.Page.SignInHint',
    PlayAgain: 'Rehearsal.Page.PlayAgain',
    ReviewTooltip: 'Rehearsal.Page.ReviewTooltip',
    ModeNeedsDocumentHint: 'Rehearsal.Page.ModeNeedsDocumentHint',
    ModeNeedsParsedPdfHint: 'Rehearsal.Page.ModeNeedsParsedPdfHint',
    ModeNoPlanHint: 'Rehearsal.Page.ModeNoPlanHint',
    FrameworkHint: 'Rehearsal.Page.FrameworkHint',
    ModeLive: 'Rehearsal.Page.ModeLive',
    ModeLiveHint: 'Rehearsal.Page.ModeLiveHint',
    ModeLiveNote: 'Rehearsal.Page.ModeLiveNote',
    ModeLiveNoteHeadphones: 'Rehearsal.Page.ModeLiveNoteHeadphones',
  },
  Metric: {
    MedianWpm: 'Rehearsal.Metric.MedianWpm',
    AvgWpm: 'Rehearsal.Metric.AvgWpm',
    VolumeRange: 'Rehearsal.Metric.VolumeRange',
    MelodyRange: 'Rehearsal.Metric.MelodyRange',
    PauseRatio: 'Rehearsal.Metric.PauseRatio',
    FillersPerMinute: 'Rehearsal.Metric.FillersPerMinute',
    ArchetypeCoverage: 'Rehearsal.Metric.ArchetypeCoverage',
    DistinctArchetypes: 'Rehearsal.Metric.DistinctArchetypes',
    Duration: 'Rehearsal.Metric.Duration',
  },
  Document: {
    Heading: 'Rehearsal.Document.Heading',
    Loading: 'Rehearsal.Document.Loading',
    TypedTalk: 'Rehearsal.Document.TypedTalk',
    Revision: 'Rehearsal.Document.Revision',
    SetOn: 'Rehearsal.Document.SetOn',
    TooLong: 'Rehearsal.Document.TooLong',
    TooFewWords: 'Rehearsal.Document.TooFewWords',
    UploadHint: 'Rehearsal.Document.UploadHint',
    UploadWrongType: 'Rehearsal.Document.UploadWrongType',
    Saving: 'Rehearsal.Document.Saving',
    SaveFailed: 'Rehearsal.Document.SaveFailed',
    Cancel: 'Rehearsal.Document.Cancel',
    Delete: 'Rehearsal.Document.Delete',
    DeleteWarningHeading: 'Rehearsal.Document.DeleteWarningHeading',
    DeleteWarningBody: 'Rehearsal.Document.DeleteWarningBody',
    DeleteConfirm: 'Rehearsal.Document.DeleteConfirm',
    DeleteFailed: 'Rehearsal.Document.DeleteFailed',
    QuotaExceeded: 'Rehearsal.Document.QuotaExceeded',
    PasteInstead: 'Rehearsal.Document.PasteInstead',
    EditorLabel: 'Rehearsal.Document.EditorLabel',
    PreviewLabel: 'Rehearsal.Document.PreviewLabel',
    LoadTextFailed: 'Rehearsal.Document.LoadTextFailed',
    SaveEdit: 'Rehearsal.Document.SaveEdit',
    Close: 'Rehearsal.Document.Close',
    DownloadOriginal: 'Rehearsal.Document.DownloadOriginal',
    DownloadFailed: 'Rehearsal.Document.DownloadFailed',
    PageIntro: 'Rehearsal.Document.PageIntro',
    Saved: 'Rehearsal.Document.Saved',
    ProposalNotice: 'Rehearsal.Document.ProposalNotice',
    ReplaceOriginal: 'Rehearsal.Document.ReplaceOriginal',
    UploadOriginal: 'Rehearsal.Document.UploadOriginal',
    Edit: 'Rehearsal.Document.Edit',
    Fullscreen: 'Rehearsal.Document.Fullscreen',
    ExitFullscreen: 'Rehearsal.Document.ExitFullscreen',
    UnparsedHeading: 'Rehearsal.Document.UnparsedHeading',
    UnparsedBody: 'Rehearsal.Document.UnparsedBody',
    UnparsedCheaper: 'Rehearsal.Document.UnparsedCheaper',
    UnparsedAssistedCost: 'Rehearsal.Document.UnparsedAssistedCost',
    Parse: 'Rehearsal.Document.Parse',
    Parsing: 'Rehearsal.Document.Parsing',
    ParseFailed: 'Rehearsal.Document.ParseFailed',
    ParseNoCredits: 'Rehearsal.Document.ParseNoCredits',
    DropTitle: 'Rehearsal.Document.DropTitle',
    DropFormats: 'Rehearsal.Document.DropFormats',
    NoFilePrompt: 'Rehearsal.Document.NoFilePrompt',
    WriteInstead: 'Rehearsal.Document.WriteInstead',
    EditLink: 'Rehearsal.Document.EditLink',
    ReplaceLink: 'Rehearsal.Document.ReplaceLink',
  },
  Plan: {
    Heading: 'Rehearsal.Plan.Heading',
    MustDeliver: 'Rehearsal.Plan.MustDeliver',
    IfTimePermits: 'Rehearsal.Plan.IfTimePermits',
    Deferrable: 'Rehearsal.Plan.Deferrable',
    BuiltFor: 'Rehearsal.Plan.BuiltFor',
    Freestyle: 'Rehearsal.Plan.Freestyle',
    PickerLabel: 'Rehearsal.Plan.PickerLabel',
    EarlierRevision: 'Rehearsal.Plan.EarlierRevision',
    NameLabel: 'Rehearsal.Plan.NameLabel',
    NameEdit: 'Rehearsal.Plan.NameEdit',
    NameTooLong: 'Rehearsal.Plan.NameTooLong',
    LengthLabel: 'Rehearsal.Plan.LengthLabel',
    Writing: 'Rehearsal.Plan.Writing',
    Rewriting: 'Rehearsal.Plan.Rewriting',
    WorkingReason: 'Rehearsal.Plan.WorkingReason',
    Ready: 'Rehearsal.Plan.Ready',
    Failed: 'Rehearsal.Plan.Failed',
    OutOfCredits: 'Rehearsal.Plan.OutOfCredits',
    Delete: 'Rehearsal.Plan.Delete',
    DeleteWarningHeading: 'Rehearsal.Plan.DeleteWarningHeading',
    DeleteWarningBody: 'Rehearsal.Plan.DeleteWarningBody',
    DeleteConfirm: 'Rehearsal.Plan.DeleteConfirm',
    CorrectionWaiting: 'Rehearsal.Plan.CorrectionWaiting',
    CorrectionReview: 'Rehearsal.Plan.CorrectionReview',
    SummaryCounts: 'Rehearsal.Plan.SummaryCounts',
    SummaryCountsMustOnly: 'Rehearsal.Plan.SummaryCountsMustOnly',
    View: 'Rehearsal.Plan.View',
    ViewUnseen: 'Rehearsal.Plan.ViewUnseen',
    CloseAria: 'Rehearsal.Plan.CloseAria',
    BuildNow: 'Rehearsal.Plan.BuildNow',
    BuildAction: 'Rehearsal.Plan.BuildAction',
    FrameworkLabel: 'Rehearsal.Plan.FrameworkLabel',
    ModelLabel: 'Rehearsal.Plan.ModelLabel',
    ModelCostOne: 'Rehearsal.Plan.ModelCostOne',
    ModelCostMany: 'Rehearsal.Plan.ModelCostMany',
    RewriteHeading: 'Rehearsal.Plan.RewriteHeading',
    RewriteBody: 'Rehearsal.Plan.RewriteBody',
    RewriteAction: 'Rehearsal.Plan.RewriteAction',
    NewPlanAction: 'Rehearsal.Plan.NewPlanAction',
    NewPlanBody: 'Rehearsal.Plan.NewPlanBody',
  },
  Cues: {
    NextPoint: 'Rehearsal.Cues.NextPoint',
    NoMorePoints: 'Rehearsal.Cues.NoMorePoints',
    StateOn: 'Rehearsal.Cues.StateOn',
    StateOff: 'Rehearsal.Cues.StateOff',
  },
  Presenter: {
    Of: 'Rehearsal.Presenter.Of',
    Next: 'Rehearsal.Presenter.Next',
    Left: 'Rehearsal.Presenter.Left',
    MustWindow: 'Rehearsal.Presenter.MustWindow',
    MustDone: 'Rehearsal.Presenter.MustDone',
    CuesOff: 'Rehearsal.Presenter.CuesOff',
    Skipped: 'Rehearsal.Presenter.Skipped',
    OnDemand: 'Rehearsal.Presenter.OnDemand',
    Ready: 'Rehearsal.Presenter.Ready',
    Timeline: 'Rehearsal.Presenter.Timeline',
  },
} as const;

export const RehearsalValues = {
  'default': {
    'Chain.PractiseLocked': 'Manual is ready now. Assisted needs a plan.',
    'Chain.PractiseTitle': 'How you\'ll practise',
    'Chain.ReviewSummary': 'A take you recorded elsewhere. AI Review reads it against this talk.',
    'Chain.ReviewTitle': 'Review',
    'Chain.SeriesTitle': 'Series',
    'Chain.StartAssistedMany': 'Assisted · {Minutes} min · cued through {Count} points of your plan',
    'Chain.StartAssistedOne': 'Assisted · {Minutes} min · cued through {Count} point of your plan',
    'Chain.StartLive': 'Live pitch · {Counterpart} · {Stance} · Interruptions: {Interruptions} · {Minutes} min, then feedback',
    'Chain.StartLiveNotReady': 'Choose who you\'re pitching to.',
    'Chain.StartLivePanel': 'Live pitch · panel of {Count} ({Counterparts}) · {Minutes} min, then feedback',
    'Chain.StartLocked': 'Pick a series first.',
    'Chain.StartManual': 'Manual · {Minutes} min · no cues',
    'Chain.StartNeedsPlan': 'Ready once you have a plan.',
    'Chain.StartPitching': 'Start pitching',
    'Chain.StartTake': 'Start take',
    'Chain.StartTitle': 'Start',
    'Chain.StepCurrent': 'You are here',
    'Chain.StepDone': 'Done',
    'Chain.StepLocked': 'Not available yet',
    'Chain.TalkIntro': 'The words you mean to say. AI turns them into a delivery plan.',
    'Chain.TalkLocked': 'Pick a series first.',
    'Chain.TalkTitle': 'Your talk',
    'Cues.NextPoint': 'Next point',
    'Cues.NoMorePoints': 'That was your last point',
    'Cues.StateOff': 'Cues off',
    'Cues.StateOn': 'Cues on',
    'Detail.Archive': 'Archive series',
    'Detail.ArchiveFailed': 'Could not change the archived state. Please try again.',
    'Detail.ArchiveHint': 'Hides the series from the picker. Nothing is deleted, and you can bring it back any time.',
    'Detail.ArchivedBanner': 'Archived {Date} — hidden from the picker. Nothing was deleted.',
    'Detail.BadgeNoReview': 'No review',
    'Detail.BadgePending': 'In review',
    'Detail.BadgeReviewed': 'Reviewed',
    'Detail.CompareWith': 'Compare with',
    'Detail.ConcludedBanner': 'Concluded {Date} — no new takes can be added. Everything here stays: your takes, their reviews and the comparison.',
    'Detail.DiffAgainst': 'Compared with take {Number}',
    'Detail.DiffHeading': 'Compared with the previous take',
    'Detail.Eyebrow': 'Take over take',
    'Detail.LoadFailed': 'Could not load this series. Please try again.',
    'Detail.Loading': 'Loading your takes…',
    'Detail.LocalOnlyTakesMany': '{Count} takes of this series are on this device only, so they are not part of the series. Save a take to your library, or request an AI Review, to add it.',
    'Detail.LocalOnlyTakesOne': '{Count} take of this series is on this device only, so it is not part of the series. Save it to your library, or request an AI Review, to add it.',
    'Detail.LockedBody': 'Record and AI-Review at least two different takes of this talk, then come back to compare them over time.',
    'Detail.LockedHeading': 'This rehearsal series',
    'Detail.LockedLead': 'One talk, rehearsed take over take, with AI Reviews that carry your progress forward.',
    'Detail.LockedTitle': 'Comparison unlocks after two reviewed takes',
    'Detail.NoReviewYet': 'No review yet',
    'Detail.NoTakesYet': 'No takes in this series yet. Rehearse this talk and your takes will appear here.',
    'Detail.NothingToCompare': 'Only one take so far — record another and the two sit side by side here.',
    'Detail.OpenReview': 'Open review',
    'Detail.RecordedAgainst': 'Recorded against revision {Revision}',
    'Detail.Rehearse': 'Rehearsal',
    'Detail.Rename': 'Rename',
    'Detail.RenameCancel': 'Cancel',
    'Detail.RenameFailed': 'Could not rename the series. Please try again.',
    'Detail.RenameLabel': 'Series title',
    'Detail.RenameSave': 'Save',
    'Detail.RequestReview': 'Request AI Review',
    'Detail.RequestReviewFailed': 'Could not request the review. Please try again.',
    'Detail.ReviewsHeading': 'Reviews',
    'Detail.SelectTake': 'Show take {Number}',
    'Detail.TakeHeading': 'Take {Number}',
    'Detail.TakenOn': 'Taken {Date}',
    'Detail.TakesHeading': 'Takes',
    'Detail.TakesSoFarMany': '{Count} reviewed takes so far',
    'Detail.TakesSoFarOne': '{Count} reviewed take so far',
    'Detail.TrendsHeading': 'Measurement trends',
    'Detail.TrendsNote': 'These are objective measurements across your takes — trends, not scores.',
    'Detail.Unarchive': 'Unarchive series',
    'Detail.UnattachedTake': 'Recording no longer available',
    'Document.Cancel': 'Cancel',
    'Document.Close': 'Close',
    'Document.Delete': 'Delete document',
    'Document.DeleteConfirm': 'Delete the document and end this series',
    'Document.DeleteFailed': 'Could not delete the talk document. Please try again.',
    'Document.DeleteWarningBody': 'This deletes your talk document and ends this series. The storage it uses is credited back. Your takes, their reviews and the comparison history stay exactly as they are — but no new recordings can be added to this series. To rehearse this talk again, start a new series.',
    'Document.DeleteWarningHeading': 'Delete this talk document?',
    'Document.DownloadFailed': 'Could not prepare that download. Please try again.',
    'Document.DownloadOriginal': 'Download original',
    'Document.DropFormats': 'PDF, Word, Markdown or plain text · up to {MaxSize}',
    'Document.DropTitle': 'Drop your talk here, or click to browse',
    'Document.Edit': 'Edit talk document',
    'Document.EditLink': 'Edit',
    'Document.EditorLabel': 'Markdown',
    'Document.ExitFullscreen': 'Exit fullscreen',
    'Document.Fullscreen': 'Fullscreen',
    'Document.Heading': 'Your talk document',
    'Document.LoadTextFailed': 'Could not load the talk document text. Please try again.',
    'Document.Loading': 'Loading your talk document…',
    'Document.NoFilePrompt': 'Haven\'t got a file?',
    'Document.PageIntro': 'Edit the Markdown — the preview shows what your talk reads like. Saving stores a new revision of the talk.',
    'Document.Parse': 'Read this PDF · {Credits} credits',
    'Document.ParseFailed': 'We could not read that PDF. Nothing was charged — try a .docx or .md file, or paste the text instead.',
    'Document.ParseNoCredits': 'You do not have enough AI credits to read this PDF. Top up, or upload the talk as a .docx or .md file instead — those are free.',
    'Document.Parsing': 'Reading your PDF…',
    'Document.PasteInstead': 'Type or paste the text instead',
    'Document.PreviewLabel': 'Preview',
    'Document.ProposalNotice': 'This is the spoken-language rewrite from your delivery plan. Your stored talk is unchanged until you save.',
    'Document.QuotaExceeded': 'You are out of cloud storage. Add more storage, or clean up some takes, then try again.',
    'Document.ReplaceLink': 'Replace',
    'Document.ReplaceOriginal': 'Replace original document',
    'Document.Revision': 'Revision {Number}',
    'Document.SaveEdit': 'Save changes',
    'Document.SaveFailed': 'Could not save the talk document. Please try again.',
    'Document.Saved': 'Saved — your talk is now at a new revision.',
    'Document.Saving': 'Saving…',
    'Document.SetOn': 'Set {Date}',
    'Document.TooFewWords': 'A talk needs at least {Min} words before it can drive a delivery plan — that is where Assisted unlocks. Keep going, or record a Manual take.',
    'Document.TooLong': 'That is over the {Max}-character limit — trim the talk before saving.',
    'Document.TypedTalk': 'Typed talk',
    'Document.UnparsedAssistedCost': 'Reading the PDF and generating a delivery plan are two separate charges. Starting a take is free.',
    'Document.UnparsedBody': 'Your file is stored, but nothing can be built from it until AI reads it into text. Until then Assisted mode stays locked and no delivery plan can be built. Reading it costs {Credits} credits, charged when you press the button.',
    'Document.UnparsedCheaper': 'Want to spend nothing? Upload the same talk as a .docx or .md file instead, or paste the text — those are converted for free.',
    'Document.UnparsedHeading': 'This PDF has not been read yet',
    'Document.UploadHint': 'A .pdf, .docx, .md, .markdown or .txt file of at least {Min} words. Word, Markdown and text files are converted for free; a PDF has to be read by AI, which costs credits.',
    'Document.UploadOriginal': 'Upload a document',
    'Document.UploadWrongType': 'We cannot read that file type. Pick a .pdf, .docx, .md, .markdown or .txt file, or type the talk instead.',
    'Document.WriteInstead': 'Write or paste it instead',
    'Listing.Archive': 'Archive',
    'Listing.ArchiveFailed': 'Could not change that series\' archived state. Please try again.',
    'Listing.ArchiveHint': 'Hides the series from the picker and this list. Nothing is deleted, and you can bring it back any time.',
    'Listing.Archived': 'Archived {Date}',
    'Listing.Concluded': 'Concluded {Date}',
    'Listing.CreatedOn': 'Started {Date}',
    'Listing.EmptyBody': 'Start a Rehearsal take and pick a series — your takes will group here.',
    'Listing.EmptyHeading': 'No series yet',
    'Listing.Heading': 'Your rehearsal series',
    'Listing.Lead': 'Every talk you rehearse, grouped by series. Open one to see its takes and reviews.',
    'Listing.LoadFailed': 'Could not load your series. Please try again.',
    'Listing.Loading': 'Loading your series…',
    'Listing.NoDocument': 'No document',
    'Listing.NoMatch': 'No series matches that search.',
    'Listing.OpenSeries': 'Open series',
    'Listing.SearchHint': 'Matches whole words in your series topics. Blank shows every series.',
    'Listing.SearchLabel': 'Search by topic',
    'Listing.ShowArchived': 'Show archived series',
    'Listing.ShowConcluded': 'Show concluded series',
    'Listing.Title': 'Your rehearsal series · VoiceDojo',
    'Listing.TotalDocumentBytes': 'Talk documents: {Size}',
    'Listing.TryRehearsal': 'Go to Rehearsal',
    'Listing.TypedTalk': 'Typed talk',
    'Listing.Unarchive': 'Unarchive',
    'Metric.ArchetypeCoverage': 'Archetype coverage',
    'Metric.AvgWpm': 'Average pace (WPM)',
    'Metric.DistinctArchetypes': 'Distinct archetypes',
    'Metric.Duration': 'Take length (min)',
    'Metric.FillersPerMinute': 'Fillers per minute',
    'Metric.MedianWpm': 'Median pace (WPM)',
    'Metric.MelodyRange': 'Melody range (Hz)',
    'Metric.PauseRatio': 'Pause ratio',
    'Metric.VolumeRange': 'Volume range (dB)',
    'Page.FormulaHeading': 'Rehearse with the Rehearsal Formula',
    'Page.FormulaIntro': 'Work up to your take through four modes — each ramps the stakes so the version you record is your best, not your first.',
    'Page.FrameworkHint': 'Your framework guides you during the take, shapes your delivery plan, and can be applied as a lens in AI Review.',
    'Page.Heading': 'Rehearsal',
    'Page.Lead': 'Rehearse one talk, take after take. Follow a delivery plan, pitch live to an AI panel, or go on your own. AI Review tracks your progress, never with scores.',
    'Page.MetaDescription': 'Rehearsal — rehearse a real talk, take after take. Your delivery plan cues you through the take, or record unassisted, and AI Review compares your takes over time.',
    'Page.ModeAssisted': 'Assisted',
    'Page.ModeAssistedHint': 'Your delivery plan cues you through the take.',
    'Page.ModeAssistedNoteOff': 'You can switch cues off mid-take.',
    'Page.ModeAssistedNotePoints': 'Each point of the plan you select appears as you reach it.',
    'Page.ModeLabel': 'Practice mode',
    'Page.ModeLive': 'Live pitch',
    'Page.ModeLiveHint': 'Pitch your talk to an AI audience you set up below.',
    'Page.ModeLiveNote': 'The chair opens by introducing the panel, then you lead. They listen, react and question you on your pitch — get ready to be roasted.',
    'Page.ModeLiveNoteHeadphones': 'Wear headphones, so they can\'t hear themselves and cut in.',
    'Page.ModeManual': 'Manual',
    'Page.ModeManualHint': 'Nothing is cued and nothing is generated — you speak from your own preparation.',
    'Page.ModeManualNoteBrowser': 'The take records in your browser.',
    'Page.ModeManualNoteUpload': 'Recorded it elsewhere? Upload that take instead, and AI Review reads it against this talk.',
    'Page.ModeNeedsDocumentHint': 'Assisted needs a delivery plan, built from a talk of at least {Min} words — add yours in Your talk.',
    'Page.ModeNeedsParsedPdfHint': 'Assisted needs a delivery plan, and your PDF has not been read yet — read it in Your talk. Reading it is one charge; building the delivery plan is a second.',
    'Page.ModeNoPlanHint': 'Assisted needs a delivery plan — build one in Your talk.',
    'Page.PlayAgain': 'Play again',
    'Page.ReviewTooltip': 'Record at least a minute to request an AI Review.',
    'Page.SignInHint': 'Sign in to pick the series you are rehearsing — a rehearsal take always belongs to one.',
    'Page.TakeKindLabel': 'Talk',
    'Page.TakeTitle': 'Your talk',
    'Page.Title': 'Rehearsal · VoiceDojo',
    'Plan.BuildAction': 'Build plan',
    'Plan.BuildNow': 'No delivery plan yet — build one from your talk.',
    'Plan.BuiltFor': '{Framework} · {Minutes} min · from revision {Revision}',
    'Plan.CloseAria': 'Close the plan',
    'Plan.CorrectionReview': 'Review the rewrite',
    'Plan.CorrectionWaiting': 'A rewrite of your talk for speaking is waiting.',
    'Plan.Deferrable': 'Better sent as a follow-up',
    'Plan.Delete': 'Delete this plan',
    'Plan.DeleteConfirm': 'Delete plan',
    'Plan.DeleteWarningBody': '“{Name}” will be removed from this series. Takes you already recorded against it keep their own copy of the plan.',
    'Plan.DeleteWarningHeading': 'Delete this delivery plan?',
    'Plan.EarlierRevision': 'from an earlier revision of your talk',
    'Plan.Failed': 'Could not build the plan. Nothing was charged — please try again.',
    'Plan.FrameworkLabel': 'Framework',
    'Plan.Freestyle': 'no framework',
    'Plan.Heading': 'Your delivery plan',
    'Plan.IfTimePermits': 'If there\'s time',
    'Plan.LengthLabel': 'Take length',
    'Plan.ModelCostMany': 'at most {Credits} credits',
    'Plan.ModelCostOne': 'at most 1 credit',
    'Plan.ModelLabel': 'Model',
    'Plan.MustDeliver': 'Must deliver',
    'Plan.NameEdit': 'Edit plan name',
    'Plan.NameLabel': 'Plan name',
    'Plan.NameTooLong': 'A plan name is limited to {Max} characters.',
    'Plan.NewPlanAction': 'New delivery plan',
    'Plan.NewPlanBody': 'We read your talk and list what you must deliver, and what to add if there\'s time.',
    'Plan.OutOfCredits': 'You do not have enough AI credits for this plan. Top up and try again.',
    'Plan.PickerLabel': 'Which plan are you rehearsing?',
    'Plan.Ready': 'Your new delivery plan is ready.',
    'Plan.RewriteAction': 'Rewrite',
    'Plan.RewriteBody': 'We rewrite your talk the way a person says it out loud — a proposal you review in the editor, never an overwrite — and build a delivery plan from the rewrite.',
    'Plan.RewriteHeading': 'Rewrite for speaking',
    'Plan.Rewriting': 'Rewriting your talk…',
    'Plan.SummaryCounts': '{Must} must deliver · {IfTime} if there\'s time',
    'Plan.SummaryCountsMustOnly': '{Must} must deliver',
    'Plan.View': 'View plan',
    'Plan.ViewUnseen': 'new, not opened yet',
    'Plan.WorkingReason': 'Still working on your talk — this can take a minute or two.',
    'Plan.Writing': 'Writing your plan…',
    'Presenter.CuesOff': 'Cues off',
    'Presenter.Left': 'left',
    'Presenter.MustDone': 'Must-deliver done · bonus time',
    'Presenter.MustWindow': 'Must-deliver: {Time} more',
    'Presenter.Next': 'Next',
    'Presenter.Of': '{N} of {Total}',
    'Presenter.OnDemand': 'Your plan, on demand.',
    'Presenter.Ready': 'Points fire as cues from Record.',
    'Presenter.Skipped': '{Count} skipped',
    'Presenter.Timeline': 'Plan timeline: must-deliver points, then if-there\'s-time points',
    'Preview.IfTimeOne': 'How onboarding actually runs',
    'Preview.IfTimeTwo': 'The competitor comparison',
    'Preview.MustOne': 'Open with the customer\'s problem, in their words',
    'Preview.MustThree': 'Ask for the next meeting',
    'Preview.MustTwo': 'The one number that makes the case',
    'Preview.PitchHeading': 'Live pitch to a panel',
    'Preview.SeriesTag': 'sales-pitch',
    'Preview.SeriesTopic': 'My sales pitch for FY26',
    'Preview.Take': 'Take {Number} · {Minutes} min',
    'Preview.TakesHeading': 'Takes in this series',
    'Resume.About': 'About Rehearsal',
    'Resume.NoTakesYet': 'no takes yet — this will be your first',
    'Resume.TakesMany': '{Count} takes',
    'Resume.TakesOne': '{Count} take',
    'Series.AllSeries': 'All your series',
    'Series.Change': 'Change series',
    'Series.CreateFailed': 'Could not create that series. Please try again.',
    'Series.Eyebrow': 'Rehearse one talk',
    'Series.FindLabel': 'Find or start a series',
    'Series.FindPlaceholder': 'Type a talk name…',
    'Series.Joined': 'Rehearsing {Tag}',
    'Series.NoMatches': 'No series matches that yet.',
    'Series.RecentGroup': 'Recent',
    'Series.Restoring': 'Loading your last series…',
    'Series.Searching': 'Loading your series…',
    'Series.SectionHeading': 'Your series',
    'Series.StartNew': 'Start a new series',
    'Series.ViewSeries': 'View this series\' takes',
    'Validations.DocumentConvertFailed': 'We could not read that file. It may be password-protected or damaged — try another file, or paste the text instead.',
    'Validations.DocumentEmpty': 'Your talk document is empty — type the talk or upload a Markdown file.',
    'Validations.DocumentTooLong': 'That talk document is too long. Trim it to under 60,000 characters.',
    'Validations.DocumentUnsupportedType': 'We cannot read that file type. Upload a .pdf, .docx, .md, .markdown or .txt file, or type the talk instead.',
    'Validations.DoesNotExist': 'That rehearsal series does not exist',
    'Validations.InvalidTag': 'A series tag must contain at least one letter or number',
    'Validations.NoDocument': 'This series has no talk document yet — add the talk first, then build its delivery plan.',
    'Validations.NothingToParse': 'There is no PDF waiting to be read on this series. It may already have been read, or the talk may have come from another kind of file.',
    'Validations.PdfTooManyPages': 'That PDF is too long. Upload a talk of 40 pages or fewer, or paste the text instead.',
    'Validations.PlanFailed': 'We could not build a delivery plan from that talk. Nothing was charged — please try again.',
    'Validations.PlanIdRequired': 'That plan request carried no plan id. Reload the page and try again.',
    'Validations.PlanInFlight': 'A delivery plan is already being built for this series. Wait for it to finish, then generate another.',
    'Validations.PlanNameTooLong': 'A plan name is limited to 60 characters. Shorten it a little.',
    'Validations.RequiresPremium': 'Rehearsal is a Premium feature. Upgrade to Premium to rehearse a talk over takes.',
    'Validations.SeriesConcluded': 'That series is concluded — no new takes can be added to it. Start a new series to rehearse this talk again.',
    'Validations.SeriesNotYours': 'That series belongs to another account, so this take cannot join it. Pick one of your own series.',
    'Validations.SeriesRequired': 'A rehearsal take belongs to a series. Pick or start a series first.',
    'Validations.SourceTooLarge': 'That file is too large. Uploads are limited to 20 MB.',
    'Validations.TagNotUnique': 'You already have a series with that tag — pick a different one or join the existing series',
    'Validations.TalkTooShort': 'A talk needs at least 50 words — below that there is not enough material to build a delivery plan from without inventing it. Add a little more, or record a Manual take.',
    'Validations.TooManyPlans': 'This series already has 10 delivery plans — delete one you no longer rehearse, then generate another.',
    'Validations.TypedTalkTooLong': 'A typed talk is limited to 1,000 words. Trim it, or upload the talk as a Markdown file instead.',
    'Validations.UnknownPlanModel': 'That model is not on this plan menu. Pick one from the list and try again.',
  },
  'vi-VN': {
    'Chain.PractiseLocked': 'Chế độ Tự chủ đã sẵn sàng. Chế độ Có hướng dẫn cần một kế hoạch.',
    'Chain.PractiseTitle': 'Bạn sẽ luyện thế nào',
    'Chain.ReviewSummary': 'Một bản ghi bạn thực hiện ở nơi khác. AI Review đọc nó theo bài nói này.',
    'Chain.ReviewTitle': 'Nhận xét',
    'Chain.SeriesTitle': 'Chuỗi bài',
    'Chain.StartAssistedMany': 'Có hướng dẫn · {Minutes} phút · nhắc theo {Count} ý trong kế hoạch của bạn',
    'Chain.StartAssistedOne': 'Có hướng dẫn · {Minutes} phút · nhắc theo {Count} ý trong kế hoạch của bạn',
    'Chain.StartLive': 'Thuyết trình trực tiếp · {Counterpart} · {Stance} · Ngắt lời: {Interruptions} · {Minutes} phút, sau đó nhận phản hồi',
    'Chain.StartLiveNotReady': 'Hãy chọn người bạn thuyết trình cho.',
    'Chain.StartLivePanel': 'Thuyết trình trực tiếp · hội đồng {Count} người ({Counterparts}) · {Minutes} phút, sau đó nhận phản hồi',
    'Chain.StartLocked': 'Hãy chọn một chuỗi bài trước.',
    'Chain.StartManual': 'Thủ công · {Minutes} phút · không có gợi ý',
    'Chain.StartNeedsPlan': 'Sẵn sàng khi bạn đã có kế hoạch.',
    'Chain.StartPitching': 'Bắt đầu thuyết trình',
    'Chain.StartTake': 'Bắt đầu ghi',
    'Chain.StartTitle': 'Bắt đầu',
    'Chain.StepCurrent': 'Bạn đang ở đây',
    'Chain.StepDone': 'Xong',
    'Chain.StepLocked': 'Chưa dùng được',
    'Chain.TalkIntro': 'Những lời bạn định nói. AI biến chúng thành một kế hoạch trình bày.',
    'Chain.TalkLocked': 'Hãy chọn một chuỗi bài trước.',
    'Chain.TalkTitle': 'Bài nói của bạn',
    'Cues.NextPoint': 'Ý tiếp theo',
    'Cues.NoMorePoints': 'Đó là ý cuối cùng của bạn',
    'Cues.StateOff': 'Tắt gợi ý',
    'Cues.StateOn': 'Bật gợi ý',
    'Detail.Archive': 'Lưu trữ chuỗi',
    'Detail.ArchiveFailed': 'Không đổi được trạng thái lưu trữ. Vui lòng thử lại.',
    'Detail.ArchiveHint': 'Ẩn chuỗi khỏi bộ chọn. Không xoá gì cả, và bạn có thể đưa nó trở lại bất cứ lúc nào.',
    'Detail.ArchivedBanner': 'Đã lưu trữ {Date} — ẩn khỏi bộ chọn. Không có gì bị xoá.',
    'Detail.BadgeNoReview': 'Chưa nhận xét',
    'Detail.BadgePending': 'Đang nhận xét',
    'Detail.BadgeReviewed': 'Đã nhận xét',
    'Detail.CompareWith': 'So sánh với',
    'Detail.ConcludedBanner': 'Đã kết thúc {Date} — không thể thêm bản thu mới. Mọi thứ ở đây vẫn còn: các bản thu, đánh giá của chúng và phần so sánh.',
    'Detail.DiffAgainst': 'So với bản thu {Number}',
    'Detail.DiffHeading': 'So với bản thu trước',
    'Detail.Eyebrow': 'Từng bản thu một',
    'Detail.LoadFailed': 'Không tải được chuỗi này. Vui lòng thử lại.',
    'Detail.Loading': 'Đang tải các bản thu của bạn…',
    'Detail.LocalOnlyTakesMany': 'Có {Count} bản thu của chuỗi này chỉ nằm trên thiết bị này, nên chúng chưa thuộc chuỗi. Hãy lưu bản thu vào thư viện, hoặc yêu cầu AI đánh giá, để thêm nó vào.',
    'Detail.LocalOnlyTakesOne': 'Có {Count} bản thu của chuỗi này chỉ nằm trên thiết bị này, nên chúng chưa thuộc chuỗi. Hãy lưu bản thu vào thư viện, hoặc yêu cầu AI đánh giá, để thêm nó vào.',
    'Detail.LockedBody': 'Hãy ghi và để AI đánh giá ít nhất hai bản thu khác nhau của bài nói này, rồi quay lại để so sánh chúng theo thời gian.',
    'Detail.LockedHeading': 'Chuỗi tập dượt này',
    'Detail.LockedLead': 'Một bài nói, tập dượt qua từng bản thu, với các lượt AI đánh giá mang tiến bộ của bạn tiến về phía trước.',
    'Detail.LockedTitle': 'Phần so sánh mở khóa sau hai bản thu được đánh giá',
    'Detail.NoReviewYet': 'Chưa có đánh giá',
    'Detail.NoTakesYet': 'Chuỗi này chưa có bản thu nào. Hãy tập dượt bài nói này và các bản thu sẽ xuất hiện ở đây.',
    'Detail.NothingToCompare': 'Mới chỉ có một bản thu — ghi thêm một bản nữa để đặt hai bản cạnh nhau ở đây.',
    'Detail.OpenReview': 'Mở đánh giá',
    'Detail.RecordedAgainst': 'Thu theo phiên bản {Revision}',
    'Detail.Rehearse': 'Tập dượt',
    'Detail.Rename': 'Đổi tên',
    'Detail.RenameCancel': 'Huỷ',
    'Detail.RenameFailed': 'Không đổi tên được chuỗi. Vui lòng thử lại.',
    'Detail.RenameLabel': 'Tiêu đề chuỗi',
    'Detail.RenameSave': 'Lưu',
    'Detail.RequestReview': 'Yêu cầu AI đánh giá',
    'Detail.RequestReviewFailed': 'Không gửi được yêu cầu đánh giá. Vui lòng thử lại.',
    'Detail.ReviewsHeading': 'Đánh giá',
    'Detail.SelectTake': 'Xem bản thu {Number}',
    'Detail.TakeHeading': 'Bản thu {Number}',
    'Detail.TakenOn': 'Thu ngày {Date}',
    'Detail.TakesHeading': 'Các bản thu',
    'Detail.TakesSoFarMany': 'Đã có {Count} bản thu được đánh giá',
    'Detail.TakesSoFarOne': 'Đã có {Count} bản thu được đánh giá',
    'Detail.TrendsHeading': 'Xu hướng các số đo',
    'Detail.TrendsNote': 'Đây là các số đo khách quan qua các bản thu của bạn — xu hướng, không phải điểm số.',
    'Detail.Unarchive': 'Bỏ lưu trữ chuỗi',
    'Detail.UnattachedTake': 'Bản thu không còn nữa',
    'Document.Cancel': 'Huỷ',
    'Document.Close': 'Đóng',
    'Document.Delete': 'Xoá tài liệu',
    'Document.DeleteConfirm': 'Xoá tài liệu và kết thúc chuỗi này',
    'Document.DeleteFailed': 'Không thể xoá tài liệu bài nói. Vui lòng thử lại.',
    'Document.DeleteWarningBody': 'Thao tác này xoá tài liệu bài nói của bạn và kết thúc chuỗi này. Dung lượng lưu trữ sẽ được hoàn lại. Các bản thu, đánh giá và lịch sử so sánh vẫn giữ nguyên — nhưng không thể thêm bản thu mới vào chuỗi này nữa. Muốn tập lại bài nói này, hãy bắt đầu một chuỗi mới.',
    'Document.DeleteWarningHeading': 'Xoá tài liệu bài nói này?',
    'Document.DownloadFailed': 'Không chuẩn bị được tệp tải xuống. Vui lòng thử lại.',
    'Document.DownloadOriginal': 'Tải tệp gốc',
    'Document.DropFormats': 'PDF, Word, Markdown hoặc văn bản thuần · tối đa {MaxSize}',
    'Document.DropTitle': 'Thả bài nói của bạn vào đây, hoặc bấm để chọn tệp',
    'Document.Edit': 'Chỉnh sửa tài liệu bài nói',
    'Document.EditLink': 'Sửa',
    'Document.EditorLabel': 'Markdown',
    'Document.ExitFullscreen': 'Thoát toàn màn hình',
    'Document.Fullscreen': 'Toàn màn hình',
    'Document.Heading': 'Tài liệu bài nói của bạn',
    'Document.LoadTextFailed': 'Không tải được nội dung tài liệu bài nói. Vui lòng thử lại.',
    'Document.Loading': 'Đang tải tài liệu bài nói…',
    'Document.NoFilePrompt': 'Chưa có tệp?',
    'Document.PageIntro': 'Sửa Markdown — bản xem trước cho thấy bài nói của bạn. Lưu sẽ tạo một phiên bản mới của bài nói.',
    'Document.Parse': 'Đọc tệp PDF này · {Credits} tín dụng',
    'Document.ParseFailed': 'Chúng tôi không đọc được tệp PDF đó. Bạn chưa bị tính phí — hãy thử tệp .docx hoặc .md, hoặc dán nội dung văn bản.',
    'Document.ParseNoCredits': 'Bạn không đủ tín dụng AI để đọc tệp PDF này. Hãy nạp thêm, hoặc tải bài nói lên dưới dạng tệp .docx hoặc .md — những cách đó miễn phí.',
    'Document.Parsing': 'Đang đọc tệp PDF của bạn…',
    'Document.PasteInstead': 'Nhập hoặc dán nội dung thay thế',
    'Document.PreviewLabel': 'Xem trước',
    'Document.ProposalNotice': 'Đây là bản viết lại theo lối nói từ kế hoạch trình bày. Bài nói đã lưu của bạn không đổi cho tới khi bạn lưu.',
    'Document.QuotaExceeded': 'Bạn đã hết dung lượng đám mây. Hãy thêm dung lượng, hoặc dọn bớt bản thu, rồi thử lại.',
    'Document.ReplaceLink': 'Thay tệp',
    'Document.ReplaceOriginal': 'Thay tài liệu gốc',
    'Document.Revision': 'Phiên bản {Number}',
    'Document.SaveEdit': 'Lưu thay đổi',
    'Document.SaveFailed': 'Không thể lưu tài liệu bài nói. Vui lòng thử lại.',
    'Document.Saved': 'Đã lưu — bài nói của bạn đã sang phiên bản mới.',
    'Document.Saving': 'Đang lưu…',
    'Document.SetOn': 'Đặt ngày {Date}',
    'Document.TooFewWords': 'Bài nói cần ít nhất {Min} từ thì mới lập được kế hoạch trình bày — đó cũng là mốc mở khoá chế độ Có trợ giúp. Hãy viết tiếp, hoặc ghi một lượt Thủ công.',
    'Document.TooLong': 'Đã vượt giới hạn {Max} ký tự — hãy rút ngắn bài nói trước khi lưu.',
    'Document.TypedTalk': 'Bài nói tự nhập',
    'Document.UnparsedAssistedCost': 'Đọc tệp PDF và tạo kế hoạch trình bày là hai khoản phí riêng. Bắt đầu một lượt thu là miễn phí.',
    'Document.UnparsedBody': 'Tệp của bạn đã được lưu, nhưng chưa thể dùng để tạo gì cho đến khi AI đọc nó thành văn bản. Trước lúc đó, chế độ Có trợ giúp vẫn bị khoá và không thể lập kế hoạch trình bày. Việc đọc tốn {Credits} tín dụng, tính phí ngay khi bạn nhấn nút.',
    'Document.UnparsedCheaper': 'Không muốn tốn tín dụng? Hãy tải cùng bài nói lên dưới dạng tệp .docx hoặc .md, hoặc dán nội dung văn bản — những cách đó được chuyển đổi miễn phí.',
    'Document.UnparsedHeading': 'Tệp PDF này chưa được đọc',
    'Document.UploadHint': 'Một tệp .pdf, .docx, .md, .markdown hoặc .txt dài từ {Min} từ trở lên. Tệp Word, Markdown và văn bản được chuyển đổi miễn phí; tệp PDF phải do AI đọc nên sẽ tốn tín dụng.',
    'Document.UploadOriginal': 'Tải tài liệu lên',
    'Document.UploadWrongType': 'Chúng tôi không đọc được loại tệp đó. Hãy chọn tệp .pdf, .docx, .md, .markdown hoặc .txt, hoặc tự nhập bài nói.',
    'Document.WriteInstead': 'Viết hoặc dán nội dung thay thế',
    'Listing.Archive': 'Lưu trữ',
    'Listing.ArchiveFailed': 'Không đổi được trạng thái lưu trữ của chuỗi đó. Vui lòng thử lại.',
    'Listing.ArchiveHint': 'Ẩn chuỗi khỏi bộ chọn và danh sách này. Không xoá gì cả, và bạn có thể đưa nó trở lại bất cứ lúc nào.',
    'Listing.Archived': 'Đã lưu trữ {Date}',
    'Listing.Concluded': 'Đã kết thúc {Date}',
    'Listing.CreatedOn': 'Bắt đầu {Date}',
    'Listing.EmptyBody': 'Hãy bắt đầu một bản thu Tập dượt và chọn một chuỗi — các bản thu của bạn sẽ được gom vào đây.',
    'Listing.EmptyHeading': 'Chưa có chuỗi nào',
    'Listing.Heading': 'Chuỗi tập dượt của bạn',
    'Listing.Lead': 'Mỗi bài nói bạn tập dượt, gom theo chuỗi. Mở một chuỗi để xem các bản thu và đánh giá của nó.',
    'Listing.LoadFailed': 'Không tải được các chuỗi của bạn. Vui lòng thử lại.',
    'Listing.Loading': 'Đang tải các chuỗi của bạn…',
    'Listing.NoDocument': 'Chưa có tài liệu',
    'Listing.NoMatch': 'Không có chuỗi nào khớp tìm kiếm đó.',
    'Listing.OpenSeries': 'Mở chuỗi',
    'Listing.SearchHint': 'Khớp nguyên từ trong chủ đề các chuỗi của bạn. Để trống để hiện tất cả.',
    'Listing.SearchLabel': 'Tìm theo chủ đề',
    'Listing.ShowArchived': 'Hiện các chuỗi đã lưu trữ',
    'Listing.ShowConcluded': 'Hiện các chuỗi đã kết thúc',
    'Listing.Title': 'Chuỗi tập dượt của bạn · VoiceDojo',
    'Listing.TotalDocumentBytes': 'Tài liệu bài nói: {Size}',
    'Listing.TryRehearsal': 'Đến trang Tập dượt',
    'Listing.TypedTalk': 'Bài nói tự nhập',
    'Listing.Unarchive': 'Bỏ lưu trữ',
    'Metric.ArchetypeCoverage': 'Độ phủ nguyên mẫu',
    'Metric.AvgWpm': 'Tốc độ trung bình (từ/phút)',
    'Metric.DistinctArchetypes': 'Số nguyên mẫu khác nhau',
    'Metric.Duration': 'Độ dài bản thu (phút)',
    'Metric.FillersPerMinute': 'Từ đệm mỗi phút',
    'Metric.MedianWpm': 'Tốc độ trung vị (từ/phút)',
    'Metric.MelodyRange': 'Biên độ giai điệu (Hz)',
    'Metric.PauseRatio': 'Tỉ lệ khoảng lặng',
    'Metric.VolumeRange': 'Biên độ âm lượng (dB)',
    'Page.FormulaHeading': 'Tập theo Công thức Tập dượt',
    'Page.FormulaIntro': 'Đi lên tới lượt ghi qua bốn chế độ — mỗi chế độ nâng mức độ để bản bạn ghi là bản tốt nhất, không phải bản đầu tiên.',
    'Page.FrameworkHint': 'Khung bạn chọn sẽ hướng dẫn trong lúc ghi, định hình kế hoạch trình bày, và có thể dùng làm lăng kính trong AI Review.',
    'Page.Heading': 'Tập dượt',
    'Page.Lead': 'Tập một bài nói qua nhiều lượt. Theo kế hoạch trình bày, thuyết trình trực tiếp trước hội đồng AI, hoặc tự tập. AI Review theo dõi tiến bộ của bạn, không bao giờ chấm điểm.',
    'Page.MetaDescription': 'Tập dượt — tập một bài nói thật, lượt này qua lượt khác. Kế hoạch trình bày nhắc bạn trong suốt lượt ghi, hoặc bạn tự ghi không cần trợ giúp, và AI Review so sánh các lượt của bạn theo thời gian.',
    'Page.ModeAssisted': 'Có trợ giúp',
    'Page.ModeAssistedHint': 'Kế hoạch trình bày nhắc bạn trong suốt lượt ghi.',
    'Page.ModeAssistedNoteOff': 'Bạn có thể tắt nhắc giữa chừng.',
    'Page.ModeAssistedNotePoints': 'Từng ý trong kế hoạch bạn chọn hiện ra khi tới lượt.',
    'Page.ModeLabel': 'Chế độ tập',
    'Page.ModeLive': 'Thuyết trình trực tiếp',
    'Page.ModeLiveHint': 'Thuyết trình cho một khán giả AI mà bạn thiết lập bên dưới.',
    'Page.ModeLiveNote': 'Chủ tọa mở đầu bằng cách giới thiệu hội đồng, sau đó bạn dẫn dắt. Họ lắng nghe, phản ứng và chất vấn bài thuyết trình của bạn — hãy sẵn sàng bị "nướng".',
    'Page.ModeLiveNoteHeadphones': 'Hãy đeo tai nghe để họ không nghe thấy chính mình và chen ngang.',
    'Page.ModeManual': 'Thủ công',
    'Page.ModeManualHint': 'Không nhắc, không sinh nội dung — bạn nói theo sự chuẩn bị của mình.',
    'Page.ModeManualNoteBrowser': 'Lượt ghi được thu ngay trong trình duyệt của bạn.',
    'Page.ModeManualNoteUpload': 'Đã ghi ở nơi khác? Hãy tải lượt đó lên, và AI Review sẽ đọc nó dựa trên bài nói này.',
    'Page.ModeNeedsDocumentHint': 'Chế độ Có trợ giúp cần một kế hoạch trình bày, lập từ bài nói từ {Min} từ trở lên — hãy thêm bài nói ở mục Bài nói của bạn.',
    'Page.ModeNeedsParsedPdfHint': 'Chế độ Có trợ giúp cần một kế hoạch trình bày, mà tệp PDF của bạn chưa được đọc — hãy đọc nó ở mục Bài nói của bạn. Đọc tệp là một khoản phí; lập kế hoạch trình bày là khoản phí thứ hai.',
    'Page.ModeNoPlanHint': 'Chế độ Có trợ giúp cần một kế hoạch trình bày — hãy lập ở mục Bài nói của bạn.',
    'Page.PlayAgain': 'Chơi lại',
    'Page.ReviewTooltip': 'Hãy ghi ít nhất một phút để có thể yêu cầu AI Review.',
    'Page.SignInHint': 'Đăng nhập để chọn chuỗi bạn đang tập — một lượt tập dượt luôn thuộc về một chuỗi.',
    'Page.TakeKindLabel': 'Bài nói',
    'Page.TakeTitle': 'Bài nói của bạn',
    'Page.Title': 'Tập dượt · VoiceDojo',
    'Plan.BuildAction': 'Lập kế hoạch',
    'Plan.BuildNow': 'Chưa có kế hoạch trình bày — hãy lập một kế hoạch từ bài nói của bạn.',
    'Plan.BuiltFor': '{Framework} · {Minutes} phút · từ phiên bản {Revision}',
    'Plan.CloseAria': 'Đóng kế hoạch',
    'Plan.CorrectionReview': 'Xem bản viết lại',
    'Plan.CorrectionWaiting': 'Bản viết lại để nói của bài nói đang chờ bạn.',
    'Plan.Deferrable': 'Nên gửi lại sau thì tốt hơn',
    'Plan.Delete': 'Xoá kế hoạch này',
    'Plan.DeleteConfirm': 'Xoá kế hoạch',
    'Plan.DeleteWarningBody': '“{Name}” sẽ bị xoá khỏi chuỗi này. Những bản thu bạn đã ghi theo kế hoạch đó vẫn giữ bản sao kế hoạch của riêng chúng.',
    'Plan.DeleteWarningHeading': 'Xoá kế hoạch trình bày này?',
    'Plan.EarlierRevision': 'từ một phiên bản cũ hơn của bài nói',
    'Plan.Failed': 'Không lập được kế hoạch. Bạn không bị trừ tín dụng nào — vui lòng thử lại.',
    'Plan.FrameworkLabel': 'Khung',
    'Plan.Freestyle': 'không khung',
    'Plan.Heading': 'Kế hoạch trình bày của bạn',
    'Plan.IfTimePermits': 'Nếu còn thời gian',
    'Plan.LengthLabel': 'Độ dài bản thu',
    'Plan.ModelCostMany': 'tối đa {Credits} tín dụng',
    'Plan.ModelCostOne': 'tối đa 1 tín dụng',
    'Plan.ModelLabel': 'Mô hình',
    'Plan.MustDeliver': 'Bắt buộc truyền tải',
    'Plan.NameEdit': 'Sửa tên kế hoạch',
    'Plan.NameLabel': 'Tên kế hoạch',
    'Plan.NameTooLong': 'Tên kế hoạch tối đa {Max} ký tự.',
    'Plan.NewPlanAction': 'Kế hoạch trình bày mới',
    'Plan.NewPlanBody': 'Chúng tôi đọc bài nói và liệt kê những ý bạn phải trình bày, cùng những ý thêm nếu còn thời gian.',
    'Plan.OutOfCredits': 'Bạn không đủ tín dụng AI cho kế hoạch này. Hãy nạp thêm rồi thử lại.',
    'Plan.PickerLabel': 'Bạn đang tập theo kế hoạch nào?',
    'Plan.Ready': 'Kế hoạch trình bày mới của bạn đã sẵn sàng.',
    'Plan.RewriteAction': 'Viết lại',
    'Plan.RewriteBody': 'Chúng tôi viết lại bài nói theo cách một người nói thành lời — một đề xuất để bạn xem lại trong trình soạn thảo, không bao giờ ghi đè — và lập kế hoạch trình bày từ bản viết lại.',
    'Plan.RewriteHeading': 'Viết lại để nói',
    'Plan.Rewriting': 'Đang viết lại bài nói của bạn…',
    'Plan.SummaryCounts': '{Must} bắt buộc · {IfTime} nếu còn thời gian',
    'Plan.SummaryCountsMustOnly': '{Must} bắt buộc',
    'Plan.View': 'Xem kế hoạch',
    'Plan.ViewUnseen': 'mới, chưa mở',
    'Plan.WorkingReason': 'Vẫn đang xử lý bài nói của bạn — việc này có thể mất một hai phút.',
    'Plan.Writing': 'Đang viết kế hoạch của bạn…',
    'Presenter.CuesOff': 'Gợi ý đang tắt',
    'Presenter.Left': 'còn lại',
    'Presenter.MustDone': 'Đã xong phần bắt buộc · thời gian thêm',
    'Presenter.MustWindow': 'Phần bắt buộc: còn {Time}',
    'Presenter.Next': 'Tiếp',
    'Presenter.Of': '{N}/{Total}',
    'Presenter.OnDemand': 'Kế hoạch của bạn, khi bạn cần.',
    'Presenter.Ready': 'Các ý sẽ hiện thành gợi ý từ lúc ghi hình.',
    'Presenter.Skipped': 'bỏ qua {Count}',
    'Presenter.Timeline': 'Dòng thời gian kế hoạch: các ý bắt buộc, rồi các ý nếu còn thời gian',
    'Preview.IfTimeOne': 'Quy trình tiếp nhận thực tế diễn ra thế nào',
    'Preview.IfTimeTwo': 'So sánh với đối thủ',
    'Preview.MustOne': 'Mở đầu bằng vấn đề của khách hàng, bằng chính lời họ',
    'Preview.MustThree': 'Đề nghị buổi gặp tiếp theo',
    'Preview.MustTwo': 'Con số duy nhất chứng minh được luận điểm',
    'Preview.PitchHeading': 'Thuyết trình trực tiếp trước hội đồng',
    'Preview.SeriesTag': 'bai-chao-hang',
    'Preview.SeriesTopic': 'Bài chào hàng của tôi cho năm tài chính 26',
    'Preview.Take': 'Lượt {Number} · {Minutes} phút',
    'Preview.TakesHeading': 'Các lượt ghi trong chuỗi này',
    'Resume.About': 'Về Tập dượt',
    'Resume.NoTakesYet': 'chưa có bản thu nào — đây sẽ là bản đầu tiên',
    'Resume.TakesMany': '{Count} bản thu',
    'Resume.TakesOne': '{Count} bản thu',
    'Series.AllSeries': 'Tất cả chuỗi của bạn',
    'Series.Change': 'Đổi chuỗi',
    'Series.CreateFailed': 'Không tạo được chuỗi đó. Vui lòng thử lại.',
    'Series.Eyebrow': 'Tập dượt một bài nói',
    'Series.FindLabel': 'Tìm hoặc bắt đầu một chuỗi',
    'Series.FindPlaceholder': 'Gõ tên bài nói…',
    'Series.Joined': 'Đang tập dượt {Tag}',
    'Series.NoMatches': 'Chưa có chuỗi nào khớp.',
    'Series.RecentGroup': 'Gần đây',
    'Series.Restoring': 'Đang tải chuỗi gần nhất của bạn…',
    'Series.Searching': 'Đang tải các chuỗi của bạn…',
    'Series.SectionHeading': 'Chuỗi của bạn',
    'Series.StartNew': 'Bắt đầu chuỗi mới',
    'Series.ViewSeries': 'Xem các bản thu của chuỗi này',
    'Validations.DocumentConvertFailed': 'Chúng tôi không đọc được tệp đó. Tệp có thể được đặt mật khẩu hoặc bị hỏng — hãy thử tệp khác, hoặc dán văn bản vào.',
    'Validations.DocumentEmpty': 'Tài liệu bài nói của bạn đang trống — hãy nhập bài nói hoặc tải lên một tệp Markdown.',
    'Validations.DocumentTooLong': 'Tài liệu bài nói đó quá dài. Hãy rút ngắn xuống dưới 60.000 ký tự.',
    'Validations.DocumentUnsupportedType': 'Chúng tôi không đọc được loại tệp đó. Hãy tải lên tệp .pdf, .docx, .md, .markdown hoặc .txt, hoặc tự nhập bài nói.',
    'Validations.DoesNotExist': 'Chuỗi tập dượt đó không tồn tại',
    'Validations.InvalidTag': 'Thẻ chuỗi phải chứa ít nhất một chữ cái hoặc chữ số',
    'Validations.NoDocument': 'Chuỗi này chưa có tài liệu bài nói — hãy thêm bài nói trước, rồi lập kế hoạch trình bày.',
    'Validations.NothingToParse': 'Chuỗi này không có tệp PDF nào đang chờ được đọc. Có thể tệp đã được đọc rồi, hoặc bài nói đến từ một loại tệp khác.',
    'Validations.PdfTooManyPages': 'Tệp PDF đó quá dài. Hãy tải lên bài nói tối đa 40 trang, hoặc dán nội dung văn bản.',
    'Validations.PlanFailed': 'Chúng tôi không lập được kế hoạch trình bày từ bài nói đó. Bạn không bị trừ tín dụng nào — vui lòng thử lại.',
    'Validations.PlanIdRequired': 'Yêu cầu kế hoạch đó không kèm mã kế hoạch. Hãy tải lại trang rồi thử lại.',
    'Validations.PlanInFlight': 'Một kế hoạch trình bày đang được tạo cho chuỗi này. Hãy đợi nó xong rồi tạo kế hoạch khác.',
    'Validations.PlanNameTooLong': 'Tên kế hoạch tối đa 60 ký tự. Hãy rút ngắn lại một chút.',
    'Validations.RequiresPremium': 'Tập dượt là tính năng Cao cấp. Hãy nâng cấp lên Cao cấp để tập dượt một bài nói qua nhiều bản thu.',
    'Validations.SeriesConcluded': 'Chuỗi đó đã kết thúc — không thể thêm bản thu mới vào nữa. Hãy bắt đầu một chuỗi mới để tập lại bài nói này.',
    'Validations.SeriesNotYours': 'Chuỗi đó thuộc về một tài khoản khác nên lượt tập này không thể thuộc về nó. Hãy chọn một chuỗi của bạn.',
    'Validations.SeriesRequired': 'Một lượt tập dượt luôn thuộc về một chuỗi. Hãy chọn hoặc bắt đầu một chuỗi trước.',
    'Validations.SourceTooLarge': 'Tệp đó quá lớn. Giới hạn tải lên là 20 MB.',
    'Validations.TagNotUnique': 'Bạn đã có một chuỗi với thẻ đó — hãy chọn thẻ khác hoặc tham gia chuỗi hiện có',
    'Validations.TalkTooShort': 'Bài nói cần ít nhất 50 từ — dưới mức đó không đủ chất liệu để lập kế hoạch trình bày mà không phải bịa ra. Hãy viết thêm một chút, hoặc ghi một lượt Thủ công.',
    'Validations.TooManyPlans': 'Chuỗi này đã có 10 kế hoạch trình bày — hãy xoá một kế hoạch bạn không còn tập nữa, rồi tạo kế hoạch mới.',
    'Validations.TypedTalkTooLong': 'Bài nói tự nhập giới hạn ở 1.000 từ. Hãy rút ngắn, hoặc tải bài nói lên dưới dạng tệp Markdown.',
    'Validations.UnknownPlanModel': 'Mô hình đó không có trong danh sách cho kế hoạch. Hãy chọn một mô hình trong danh sách rồi thử lại.',
  },
} as const;

